import { useDispatch, useSelector } from "react-redux"
import {
    usePost,
} from "../../api/reactQueryCustomHooks"
import { apiRoute, GetLoginCredentialDb, linksUrl } from "../../constants/enum"
import {
    ErrorCard,
    LoadingCard,
    MainContainer,
    MasterGrid,
    NextUITable,
} from "../../components"
import {
    Button
} from "@nextui-org/react"
import { LocalizationProvider, DatePicker } from '@mui/x-date-pickers';
import dayjs from "dayjs"
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs"
import { useNavigate } from "react-router-dom"
import { useEffect, useMemo, useState } from "react"
import { format } from "date-fns";

const StockDetailReport = () => {
    let navigate = useNavigate()
    const { token, user } = useSelector((state) => state.auth)
    const { compCode, compName, isMultipleCompany, startDate, endDate, yearId } = useSelector((state) => state.company)
    const frDate = (date) => (date ? format(new Date(date), "yyyy-MM-dd") : null);
    const [chalDate, setChalDate] = useState({
        fromDate: frDate(startDate) || null,
        toDate: frDate(endDate) || null
    })

    useEffect(() => {
        if (isMultipleCompany)
            navigate(linksUrl.dashboard.tradingDashboard)
    }, [])
    const [stockFilter, setStockFilter] = useState({ accessor: "SummaryBalancePcs", type: "ALL", min: '', max: '', includeZero: false });
    // "ALL" | "POSITIVE" | "ZERO"
    const columns = [
        { header: "Item", accessor: "Item_Desc", type: "text", filterable: true, sortable: false },
        { header: "Inward Qty", accessor: "InwardPcs", type: "number", filterable: true, align: "right", sortable: true },
        { header: "Outward Qty", accessor: "OutwardPcs", type: "number", filterable: true, align: "right", sortable: false },
        { header: "Balance Qty", accessor: "SummaryBalancePcs", type: "number", filterable: true, align: "right", excludeNegative: true, sortable: false, },
    ];
    const detailColumns = [
        { header: "Item", accessor: "Item_Desc", type: "text", filterable: false, sortable: false },
        { header: "Transaction Date", accessor: "Chal_Date", type: "date", align: "center", filterable: false, sortable: false },
        { header: "Chal no", accessor: "Chal_No", type: "text", filterable: false, sortable: false },
        { header: "Inward Qty", accessor: "InwardPcs", type: "number", filterable: false, align: "right", sortable: false },
        { header: "Outward Qty", accessor: "OutwardPcs", type: "number", filterable: false, align: "right", sortable: false },
        { header: "Balance", accessor: "DetailBalancePcs", type: "number", filterable: false, align: "right", sortable: false, islastValue: true },
        { header: "Remark", accessor: "PartyRemark", type: "text", filterable: false, width: "200px", sortable: false, },
    ]


    const {
        isError,
        isPending,
        data = [],
        mutate: filterData
    } = usePost({
        url: apiRoute.catalogEntry.fetch,
        queryKey: "Stock Details",
    })

    //console.log(GetLoginCredentialDb())
    const funFilterData = () => {
        filterData({
            data: {
                compcode: compCode.join(","),
                fromdate: chalDate?.fromDate,
                todate: chalDate?.toDate,
                billtype: '',
                action: "DETAIL"
            }
        })
    }
    const handleFilter = () => {
        funFilterData();
    }
    const handleClear = () => {
        setChalDate({
            fromDate: startDate || null,
            toDate: endDate || null
        })
        filterData({
            data: {
                compcode: compCode.join(","),
                fromdate: chalDate?.fromDate,
                todate: chalDate?.toDate,
                billtype: '',
                action: "DETAIL"
            }
        })
    }
    const formatDate = (date) => {
        return new Date(date).toLocaleDateString("en-GB");
    };

    if (isError) {
        return <ErrorCard />
    }

    if (isPending) {
        return <LoadingCard />
    }
    console.log(data)

    return (
        <div>
            <MainContainer
                pageName="Product Catalog Stock Details"
                info={[]}
                breadcrumbs={["Product Catalog", "Stock Details"]}
            >
                <div className="p-2 shadow mb-5">
                    {/* <div className="pb-1 text-sm font-semibold">
                        Inward Date
                    </div> */}
                    <div className="flex gap-2   flex-wrap sm:flex-nowrap md:flex-nowrap justify-center items-center gap-5 ">
                        <div className="flex no-wrap gap-5">
                            <LocalizationProvider dateAdapter={AdapterDayjs}>
                                <DatePicker
                                    label={"From Date"}
                                    views={["day", "month", "year"]}
                                    size="small"
                                    format="DD/MM/YYYY"
                                    value={
                                        chalDate.fromDate
                                            ? dayjs(chalDate.fromDate)
                                            : chalDate.fromDate
                                    }
                                    onChange={(newValue) => {
                                        setChalDate((prev) => {
                                            return {
                                                ...prev,
                                                fromDate: newValue != '' && newValue != 'Invalid Date' ?
                                                    dayjs(newValue).format("YYYY-MM-DD") : null,
                                            };
                                        });
                                    }}
                                    slotProps={{
                                        textField: { size: "small", },
                                    }}
                                />
                            </LocalizationProvider>
                            <LocalizationProvider dateAdapter={AdapterDayjs}>
                                <DatePicker
                                    label={"To  Date"}
                                    views={["day", "month", "year"]}
                                    format="DD/MM/YYYY"
                                    size="small"
                                    value={
                                        chalDate.toDate
                                            ? dayjs(chalDate.toDate)
                                            : chalDate.toDate
                                    }
                                    onChange={(newValue) => {
                                        setChalDate((prev) => {
                                            return {
                                                ...prev,
                                                toDate: newValue != '' && newValue != 'Invalid Date' ?
                                                    dayjs(newValue).format("YYYY-MM-DD") : null,
                                            };
                                        });
                                    }}
                                    slotProps={{
                                        textField: { size: "small", },
                                    }}
                                />
                            </LocalizationProvider>
                        </div>
                        <div className="flex no-wrap gap-5 justify-center items-center">
                            <Button onPress={handleFilter} className="font-semibold uppercase bg-slate-700 text-white" variant="solid" color="primary" size="sm" >Get Data</Button>
                            <Button onPress={handleClear} className="font-semibold uppercase " variant="solid" color="danger" size="sm" >Reset Date</Button>
                        </div>
                    </div>
                </div>
                <div></div>
                {data && data.length > 0 && (
                    <div className="flex flex-col gap-3 mb-4 p-3 bg-gray-50 border rounded-md shadow-sm">

                        {/* STOCK OPTIONS - ALWAYS ONE LINE */}
                        <div className="flex items-center gap-4 flex-wrap">

                            {/* IN STOCK */}
                            <label className="flex items-center gap-2 cursor-pointer text-sm font-medium text-gray-700 hover:text-green-600 transition">
                                <input
                                    type="checkbox"
                                    checked={stockFilter?.type === "POSITIVE"}
                                    onChange={(e) =>
                                        setStockFilter({
                                            ...stockFilter,
                                            type: e.target.checked ? "POSITIVE" : "ALL",
                                        })
                                    }
                                    className="w-4 h-4 accent-green-600"
                                />
                                <span>In Stock</span>
                            </label>

                            {/* OUT OF STOCK */}
                            <label className="flex items-center gap-2 cursor-pointer text-sm font-medium text-gray-700 hover:text-red-600 transition">
                                <input
                                    type="checkbox"
                                    checked={stockFilter?.type === "ZERO"}
                                    onChange={(e) =>
                                        setStockFilter({
                                            ...stockFilter,
                                            type: e.target.checked ? "ZERO" : "ALL",
                                        })
                                    }
                                    className="w-4 h-4 accent-red-600"
                                />
                                <span>Out of Stock</span>
                            </label>

                        </div>

                        {/* BALANCE QTY */}
                        <div className="flex flex-col sm:flex-row sm:items-center gap-2 w-full">
                            <span className="text-sm font-medium text-gray-700 whitespace-nowrap">
                                Balance Qty:
                            </span>

                            <div className="flex items-center gap-2 w-full">
                                <input
                                    type="number"
                                    placeholder="Min"
                                    className="w-1/2 min-w-0 px-2 py-1 border rounded text-sm"
                                    value={stockFilter.min}
                                    onChange={(e) =>
                                        setStockFilter((prev) => ({ ...prev, min: e.target.value }))
                                    }
                                />

                                <span className="text-gray-500 text-sm">to</span>

                                <input
                                    type="number"
                                    placeholder="Max"
                                    className="w-1/2 min-w-0 px-2 py-1 border rounded text-sm"
                                    value={stockFilter.max}
                                    onChange={(e) =>
                                        setStockFilter((prev) => ({ ...prev, max: e.target.value }))
                                    }
                                />
                            </div>
                        </div>

                    </div>
                )}
                <MasterGrid
                    columns={columns}
                    detailColumns={detailColumns}
                    groupKey={"Item_Desc"}
                    data={data}
                    className={""}
                    showPaging={false}
                    pageSize={10}
                    expandableRow={true}
                    showDiffBal={false}
                    stockFilter={stockFilter}// 👈 ADD THIS
                    headClass={"bg-sky-600 border-1 text-white border-slate-300 font-semibold"}
                    filterClass={"bg-sky-50 border-1 border-slate-300"}
                    footerClass={"bg-sky-600 text-white"}
                    style={{ border: "1px solid red" }}
                    exportHeader={{
                        companyName: compName.join(","),
                        reportName: `Product Catalog Stock Details From Date ${formatDate(chalDate.fromDate)} To ${formatDate(chalDate.toDate)}`,

                    }}
                ></MasterGrid>

            </MainContainer>
        </div>
    )
}
export default StockDetailReport
